import { render, staticRenderFns } from "./VoyageList.vue?vue&type=template&id=da8fdd16&scoped=true&"
import script from "./VoyageList.vue?vue&type=script&lang=js&"
export * from "./VoyageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8fdd16",
  null
  
)

export default component.exports